import {
  GET_USER_LIST_DATA_REQUEST,
  GET_USER_LIST_DATA_SUCCESS,
  GET_USER_LIST_DATA_FAILURE,
  GET_USERS_DROPDOWN_REQUEST,
  GET_USERS_DROPDOWN_SUCCESS,
  GET_USERS_DROPDOWN_FAILURE,
  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAILURE,
  SAVE_AGENT_PROMPT_REQUEST,
  SAVE_AGENT_PROMPT_SUCCESS,
  SAVE_AGENT_PROMPT_FAILURE,
} from '../actions/userActions';

const initialState = {
  loading: false,
  list: [],
  error: null,
  pagination: {
    totalCount: 0,
    page: 1,
    limit: 50,
  },
  dropdown: {
    loading: false,
    error: null,
    users: [],
  },
  byId: {
    loading: false,
    error: null,
    data: null,
  },
  promptSave: {
    loading: false,
    error: null,
    data: null,
    lastSavedAt: null,
  },
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case GET_USER_LIST_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_USER_LIST_DATA_SUCCESS: {
      const payload = action.payload || {};
      // Accept multiple possible shapes: { data: [...] } or [...] or { list: [...], total }
      const dataList = Array.isArray(payload)
        ? payload
        : (payload.data && Array.isArray(payload.data))
          ? payload.data
          : (payload.list && Array.isArray(payload.list))
            ? payload.list
            : [];

      const totalCount = payload.totalCount || payload.total || payload.count || dataList.length || 0;
      const page = payload.page || state.pagination.page;
      const limit = payload.limit || state.pagination.limit;

      return {
        ...state,
        loading: false,
        list: dataList,
        pagination: {
          totalCount,
          page,
          limit,
        },
      };
    }
    case GET_USER_LIST_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to fetch user list data',
      };
    case GET_USERS_DROPDOWN_REQUEST:
      return {
        ...state,
        dropdown: {
          ...state.dropdown,
          loading: true,
          error: null,
        },
      };
    case GET_USERS_DROPDOWN_SUCCESS: {
      const payload = action.payload || {};
      const users = Array.isArray(payload)
        ? payload
        : (payload.data && Array.isArray(payload.data))
          ? payload.data
          : (payload.users && Array.isArray(payload.users))
            ? payload.users
            : [];
      return {
        ...state,
        dropdown: {
          loading: false,
          error: null,
          users,
        },
      };
    }
    case GET_USERS_DROPDOWN_FAILURE:
      return {
        ...state,
        dropdown: {
          ...state.dropdown,
          loading: false,
          error: action.error || 'Failed to fetch users dropdown list',
        },
      };
    case GET_USER_BY_ID_REQUEST:
      return { ...state, byId: { loading: true, error: null, data: null } };
    case GET_USER_BY_ID_SUCCESS:
      return { ...state, byId: { loading: false, error: null, data: action.payload } };
    case GET_USER_BY_ID_FAILURE:
      return { ...state, byId: { loading: false, error: action.error, data: null } };

    case SAVE_AGENT_PROMPT_REQUEST:
      return { ...state, promptSave: { ...state.promptSave, loading: true, error: null } };
    case SAVE_AGENT_PROMPT_SUCCESS:
      return { ...state, promptSave: { loading: false, error: null, data: action.payload, lastSavedAt: Date.now() } };
    case SAVE_AGENT_PROMPT_FAILURE:
      return { ...state, promptSave: { ...state.promptSave, loading: false, error: action.error } };
    default:
      return state;
  }
}


